import React, { useContext } from "react";
import { useAppDispatch } from "store/hooks";
import { showError } from "store/reducers/errorReducer";
import { API } from "aws-amplify";
import { Button, InputLabel, Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { DialogWindow } from "UI/DialogWindow";
import { FormTextField } from "UI/FormTextField";
import { required } from "models/validations";
import { GlobalContext } from "store/globalContext";
import { useCreateApiCall } from "hooks/useCreateApiCall";
import { useCloseAndReset } from "hooks/useCloseAndReset";

export const EditRegionDialog = ({ region, handleClose, refreshList }) => {
  const { createApiCall } = useCreateApiCall();
  const dispatch = useAppDispatch();
  const { showWarning } = useContext(GlobalContext);

  const { control, handleSubmit, getValues, reset, formState: { isDirty } } = useForm({
    values: region,
  });

  const forceCloseAndReset = () => {
    reset();
    handleClose();
  };

  const handleDelete = createApiCall(async () => {
    const body = getValues();
    const result = await API.del("restApi", "/regions", {
      body,
    });

    if (result?.error) {
      console.error(result.error);
      dispatch(showError(result.error));
      return;
    }

    showWarning({
      title: (
        <Stack justifyContent={"center"} alignItems={"center"} gap={3}>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            Region deleted successfully
          </Typography>
        </Stack>
      ),
      content: <></>,
    });

    refreshList();
    forceCloseAndReset();
  });

  const onSubmit = createApiCall(async () => {
    const body = getValues();
    const result = await API.post("restApi", "/region_update", {
      body,
    });

    if (result?.error) {
      console.error(result.error);
      dispatch(showError(result.error));
      return;
    }

    showWarning({
      title: (
        <Stack justifyContent={"center"} alignItems={"center"} gap={3}>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            Region updated successfully
          </Typography>
        </Stack>
      ),
      content: <></>,
    });

    refreshList();
    forceCloseAndReset();
  });

  const closeAndReset = useCloseAndReset(forceCloseAndReset, isDirty);


  return (
    <DialogWindow
      open={!!region}
      withCloseButton
      handleClose={closeAndReset}
      title={"Edit Region"}
      content={
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack alignItems={"flex-start"}>
            <InputLabel htmlFor="label">Region name</InputLabel>
            <FormTextField
              id="label"
              name="label"
              control={control}
              rules={{ required }}
            />
          </Stack>
        </form>
      }
      actions={
        <Stack
          mt={2}
          mb={2}
          width={"100%"}
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={1}
        >
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete Region
          </Button>
          <Button variant="contained" onClick={handleSubmit(onSubmit)} disabled={!isDirty}>
            Save Changes
          </Button>
        </Stack>
      }
    />
  );
};
